module.exports = __webpack_public_path__ + "static/media/picup_logo.054d993f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/portfolios/picup_logo.png
// module id = 287
// module chunks = 0